import { render, staticRenderFns } from "./Videomatting.vue?vue&type=template&id=66bea70f&scoped=true"
import script from "./Videomatting.vue?vue&type=script&lang=js"
export * from "./Videomatting.vue?vue&type=script&lang=js"
import style0 from "./Videomatting.vue?vue&type=style&index=0&id=66bea70f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bea70f",
  null
  
)

export default component.exports